import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ScoringGuideDownloadButton from 'legacy/src/components/pdf/ScoringGuideDownloadButton';
import dayjs from 'dayjs';
import { sendToTelemetry, TLTRY_DEFAULTS } from 'legacy-src/utility/telemetry';

const ScoringGuideAction = (props) => {
  const [scoringGuideFreshCopy, setScoringGuideFreshCopy] = useState(false);
  // based on conversation with Nuri, IF after deleting no questions left
  // DONT save this assessments, e.g. don't save quiz with 0 questions
  //setScoringGuideFreshCopy(true);
  const {
    assessmentId,
    associatedResources,
    label,
    className,
    role,
    featureFlag: { show_attestation_confirmation_dialog: showAttestationFlag },
    userData: { isStudent, me },
    subjectData: { id: masterSubjectId, isPreApSubject },
    assesmentType = {},
  } = props;

  const onSendTelemetryEvent = () => {
    const { id: amUserId, pilot } = window.current_user || {};
    const { initId: userId } = me;
    const payload = {
      app: 'assessment_preview',
      event_type: 'action_scoring_guide',
      params: {
        item_id: assessmentId,
      },
      user: {
        am_user_id: amUserId,
        pilot,
        cb_user_id: userId,
      },
      context: {
        subject_id: masterSubjectId,
        ...assesmentType,
      },
      timestamp: dayjs(),
    };
    sendToTelemetry(Object.assign(payload, TLTRY_DEFAULTS[0]));
  };

  const onDownload = (downloadFreshCopy) => {
    downloadFreshCopy && setScoringGuideFreshCopy(false);
  };

  return (
    <ScoringGuideDownloadButton
      showIcons
      className={className}
      downloadFreshCopy={scoringGuideFreshCopy}
      masterSubjectId={masterSubjectId}
      isPreApSubject={isPreApSubject}
      assessmentId={assessmentId}
      isStudent={isStudent}
      showAttestationFlag={showAttestationFlag}
      associatedResources={associatedResources}
      onDownload={onDownload}
      label={label}
      role={role}
      onSendTelemetryEvent={onSendTelemetryEvent}
    />
  );
};

ScoringGuideAction.propTypes = {
  assessmentId: PropTypes.string.isRequired,
  associatedResources: PropTypes.object.isRequired,
  label: PropTypes.any,
  className: PropTypes.string,
  role: PropTypes.string,
};

ScoringGuideAction.defaultProps = {
  label: '',
  className: '',
  role: 'button',
};

const mapStateToProps = (state) => {
  const { featureFlag, userData, subject } = state;
  return {
    featureFlag,
    userData,
    subjectData: subject.data,
  };
};

export default connect(mapStateToProps)(ScoringGuideAction);
